<!-- @format -->

<app-datagrid #datagrid [options]="options">
  <sesio-loader datagrid-spinner></sesio-loader>
</app-datagrid>
